import Smartphones from 'Vacancies/views/VacanciesView/containers/Smartphones'
import Tablets from 'Vacancies/views/VacanciesView/containers/Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const VacanciesView = getCurrentDeviceView(Smartphones, Tablets)

export default VacanciesView
